<template>
  <LightBoxPopup
    group="shipped-from"
    contentId="product-shipped-from-popup-content"
    ref="shippedFromPopup"
  >
    <div class="product__option">
      <template v-if="isExpressShippingChina">
        <!-- start logic apply for camp mth7138 -->
        <h2 class="bordered-bottom">Estimated Shipping Time</h2>
        <template
          v-if="
            requestLocation.countryCode?.toUpperCase() == US_COUNTRY_CODE &&
            hasShipFromUsProductTag &&
            !typeSelectedHiddenShippingFromUS
          "
        >
          <h2>Produced in and Shipped from the US</h2>
          <ProductShippingSummary
            :product-shipping="
              productStore.shippingFromUS || fixedShippingFromUS
            "
          ></ProductShippingSummary>
        </template>
        <template v-if="productStore.selectedShippedOption != US_COUNTRY_CODE">
          <p class="product__shipping-from-title mb-md">
            Produced in and
            <span style="color: red">Express Shipped</span> from Overseas
          </p>
          <ProductShippingSummary
            :product-shipping="expressShipping"
          ></ProductShippingSummary>
        </template>

        <p class="product__shipping-from-title">
          Produced in and Shipped from Overseas
        </p>
        <ProductShippingSummary
          :product-shipping="
            productStore.shippingFromChina || fixedShippingFromChina
          "
        ></ProductShippingSummary>
        <!-- end logic apply for camp mth7138 -->
      </template>
      <template
        v-else-if="
          showExpressShipping &&
          isExpressShipping &&
          (!productStore.selectedShippedOption ||
            productStore.selectedShippedOption == US_COUNTRY_CODE)
        "
      >
        <h2 class="bordered-bottom">Estimated Shipping Time from the US</h2>
        <div>
          The estimated shipping time applies to the
          <strong
            >continental US, excluding AK, HI, US Military, US Islands.</strong
          >
        </div>
        <h2 class="mt-md">Express Shipping from the US</h2>
        <ProductShippingSummary
          :product-shipping="expressShipping"
        ></ProductShippingSummary>
        <h2 class="mt-md">Standard Shipping from the US</h2>
        <ProductShippingSummary></ProductShippingSummary>
      </template>
      <template v-else>
        <template v-if="isExpressShipping">
          <h2 class="bordered-bottom">Estimated Shipping Time</h2>
          <div>
            <p>
              The shipping time for <b> US-made is faster </b> than for
              overseas-made.
            </p>
            <p v-if="isUSALocation">
              The estimated shipping time applies to the
              <strong
                >continental US, excluding AK, HI, US Military, US
                Islands.</strong
              >
            </p>
            <!-- <p>
            The <b> product quality</b> of both the US-made tumblers and the
            overseas-made tumblers are <b> identical</b>. However, the selling
            price of the US-made tumblers is higher due to higher production cost.
          </p> -->
          </div>
          <br />
          <h2
            class="mt-md"
            style="display: inline"
            v-if="hasExpressShippingChinaProductTag"
          >
            Produced in and <span style="color: red">Express Shipped</span> from
            Overseas
          </h2>
          <h2 v-else class="mt-md" style="display: inline">
            Produced in and <span style="color: red">Express Shipped</span> from
            the US
          </h2>
          <ProductShippingSummary
            :product-shipping="expressShipping"
          ></ProductShippingSummary>
          <br />
          <h2>Produced in and Standard Shipped from the US</h2>
          <ProductShippingSummary
            :product-shipping="
              productStore.shippingFromUS || fixedShippingFromUS
            "
          ></ProductShippingSummary>
          <br />
          <h2>Produced in and Shipped from Overseas</h2>
          <ProductShippingSummary
            :product-shipping="
              productStore.shippingFromChina || fixedShippingFromChina
            "
          ></ProductShippingSummary>
        </template>
        <template v-else>
          <h2 class="bordered-bottom">Estimated Shipping Time</h2>
          <div>
            <p>
              The shipping time for <b> US-made is faster </b> than for
              overseas-made.
            </p>
            <p v-if="isUSALocation">
              The estimated shipping time applies to the
              <strong
                >continental US, excluding AK, HI, US Military, US
                Islands.</strong
              >
            </p>
            <!-- <p>
            The <b> product quality</b> of both the US-made tumblers and the
            overseas-made tumblers are <b> identical</b>. However, the selling
            price of the US-made tumblers is higher due to higher production cost.
          </p> -->
          </div>
          <br />
          <h2>Produced in and Shipped from the US</h2>
          <ProductShippingSummary
            :product-shipping="
              productStore.shippingFromUS || fixedShippingFromUS
            "
          ></ProductShippingSummary>
          <br />
          <h2>Produced in and Shipped from Overseas</h2>
          <ProductShippingSummary
            :product-shipping="
              productStore.shippingFromChina || fixedShippingFromChina
            "
          ></ProductShippingSummary>
        </template>
      </template>
    </div>
  </LightBoxPopup>
</template>

<script lang="ts" setup>
import LightBoxPopup from '@/ui-kits/LightBoxPopup.vue'
import ProductShippingSummary from './ProductShippingSummary.vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useProductShipping } from './composables/useProductShipping'
import {
  PRODUCT_TAG_EXPRESS_SHIPPING_CHINA,
  PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX,
  US_COUNTRY_CODE,
  PRODUCT_HANDLE_CAMP_WIN,
  TYPE_OPTIONS,
  PRODUCT_TAG_SHIP_FROM_US,
} from '@/utils'
import useProductStore from '@/store/product'
import { isProductHasTagStartWith, isProductHasTags } from '@/utils/product'
import useRequestLocationStore from '@/store/requestLocation'
import LocationService from '@/services/location'

withDefaults(defineProps<{ showExpressShipping?: boolean }>(), {
  showExpressShipping: false,
})

defineExpose({
  show,
})
const shippedFromPopup = ref<typeof LightBoxPopup | null>(null)
const { fixedShippingFromChina, fixedShippingFromUS } = useProductShipping()
const productStore = useProductStore()
const requestLocation = useRequestLocationStore()

const isUSALocation = computed(
  () =>
    requestLocation.countryCode?.toLowerCase() == US_COUNTRY_CODE.toLowerCase()
)

const isExpressShipping = computed(() => {
  return (
    isProductHasTagStartWith(
      productStore.product,
      PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX
    ) && isUSALocation.value
  )
})

const expressShippingLocation = ref<any>(null)
const expressShipping = computed(() => {
  if (expressShippingLocation.value) {
    return expressShippingLocation.value
  }

  const { maximumShipping, minimumShipping, processing } =
    productStore.productExpressShippingTime

  return {
    maximum_shipping: maximumShipping,
    minimum_shipping: minimumShipping,
    processing,
    ship_from: US_COUNTRY_CODE,
  }
})

const hasShipFromUsProductTag = computed(() =>
  isProductHasTags(productStore.product, [PRODUCT_TAG_SHIP_FROM_US])
)

const isExpressShippingChina = computed(() => {
  return (
    isProductHasTagStartWith(
      productStore.product,
      PRODUCT_TAG_EXPRESS_SHIPPING_PREFIX
    ) &&
    hasExpressShippingChinaProductTag.value &&
    isUSALocation.value
  )
})

const hasExpressShippingChinaProductTag = computed(() => {
  return isProductHasTags(productStore.product, [
    PRODUCT_TAG_EXPRESS_SHIPPING_CHINA,
  ])
})

const typeSelectedHiddenShippingFromUS = computed(() => {
  return (
    productStore.product?.handle == PRODUCT_HANDLE_CAMP_WIN &&
    (getSelectedOption(TYPE_OPTIONS) == 'Zip Hoodie' ||
      getSelectedOption(TYPE_OPTIONS) == 'Fleece Zip Hoodie' ||
      getSelectedOption(TYPE_OPTIONS) == 'Kid Hoodie')
  )
})

onMounted(() => {
  watch(
    () => productStore.productExpressShippingTime,
    () => {
      LocationService.onLocationReady((location) => {
        // const temp = [
        //   'MI',
        //   'IN',
        //   'OH',
        //   'PA',
        //   'NY',
        //   'CT',
        //   'NJ',
        //   'DE',
        //   'MD',
        //   'VA',
        //   'NC',
        //   'SC',
        //   'GA',
        //   'KY',
        //   'WV',
        //   'WI',
        //   'IL',
        //   'MN',
        //   'IA',
        //   'TN',
        // ]
        // if (
        //   isExpressShipping.value &&
        //   location?.region_code &&
        //   temp.includes(location?.region_code)
        // ) {
        //   // do nothing
        // } else {
          const { maximumShipping, minimumShipping, processing } =
            productStore.productExpressShippingTime

          expressShippingLocation.value = {
            maximum_shipping: maximumShipping + 1,
            minimum_shipping: minimumShipping,
            processing,
            ship_from: US_COUNTRY_CODE,
          // }
        }
      })
    }
  )
})

function show() {
  if (shippedFromPopup.value) shippedFromPopup.value.show()
}

function getSelectedOption(name: string = '') {
  if (!productStore.selectedVariant?.selectedOptions) return ''
  const selectedOption = productStore.selectedVariant.selectedOptions.find(
    (o) => o.name === name
  )
  if (!selectedOption) return ''
  return selectedOption.value
}
</script>
